import { useEffect } from 'react';
import { ensureTurnstileScript } from './turnstileScript';

/** React boundary for the sign-in screen's bot-protection dependency. */
export function TurnstileRuntime() {
  useEffect(() => {
    ensureTurnstileScript();
  }, []);

  return null;
}
